import { useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../Moduels/Context/AuthContext";
import { getStoredAccessToken, clearAuthSession } from "../utils/authSession";
import BrixigoPageLoader from "./common/BrixigoPageLoader";

export default function Protected({ children }) {
  const { loading, user } = useContext(AuthContext);
  const token = getStoredAccessToken();

  useEffect(() => {
    if (!loading && token && !user) {
      clearAuthSession("protected_route_without_profile");
    }
  }, [loading, token, user]);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (loading) {
    return <BrixigoPageLoader message="Loading your workspace…" />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
